import Navbar from '@/components/feature/Navbar';
import ContactFooter from './components/ContactFooter';
import ContactHero from './components/ContactHero';

export default function Contact() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <ContactHero />
      </main>
      <ContactFooter />
    </div>
  );
}